module.exports = __webpack_public_path__ + "img/ИФ-1(А)-014-m.5ab7a3c8.png";